import React from 'react';
import Header from '../component/layout/Header';
import Hero from '../component/home/Hero';
import About from '../component/home/About';
import Service from '../component/home/Service';
import Feature from '../component/home/Feature';
import Growth from '../component/home/Growth';
import Clients from '../component/home/Clients';
import Footer from '../component/layout/Footer';

export default function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Service />
      <Feature />
      <Growth />
      <Clients />
      <Footer />
    </div>
  )
}
